import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import postscribe from 'postscribe'
import customSelect from 'custom-select'
import {useSelector} from 'react-redux'

import trads from '../../intl/trads.json'

const Form = ({data}) => {
  const { ref, inView} = useInView({ threshold: 0.25, triggerOnce: true})
  const form = React.createRef()
  const lang = useSelector(state => state.lang)

  const formTitle = (data.formTitle.formTitle) ? data.formTitle.formTitle : data.formTitle
  const formChapo = (data.formChapo.formChapo) ? data.formChapo.formChapo : data.formChapo
 
  useEffect(() => {
    if (form.current !== null) {
      postscribe(form.current, `<script type="text/javascript" src="https://terega.formstack.com/forms/js.php/${data.formId}"></script>`,
        { done: function() {
          const formSelector = document.querySelector('.contact .fsPage')

          // security, without it sometimes form not loaded
          if(formSelector === null) {
            postscribe(form.current, `<script type="text/javascript" src="https://terega.formstack.com/forms/js.php/${data.formId}"></script>`)
          } else {
            // selects
            const selects = formSelector.querySelectorAll('select')

            selects.forEach(select => {
              if (!select.closest('[fs-field-type="datetime"]')) {
                const customSelectEl = customSelect(select)

                const iconContainer = document.createElement('div')
                iconContainer.innerHTML = `
                  <div class="custom-select-icon-wrapper">
                    <svg class="custom-select-icon" width="32" height="32" viewBox="0 0 48 48">
                      <path d="M18.395 12.39a1.363 1.363 0 0 1 1.782-.11l.128.11 10.8 10.667c.486.48.524 1.237.112 1.76l-.112.126-10.8 10.666c-.528.521-1.382.521-1.91 0a1.321 1.321 0 0 1-.112-1.76l.112-.125L28.24 24l-9.845-9.724a1.321 1.321 0 0 1-.112-1.76l.112-.125z" fillRule="nonzero"/>
                    </svg>
                  </div>
                `
                customSelectEl[0].container.appendChild(iconContainer.firstElementChild)
              }
            })

            // inputs
            formSelector.querySelectorAll('.fsForm input:not([type="hidden"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]), .fsForm textarea').forEach(input => {
              input.addEventListener('blur', () => {
                if(input.value !== '') {
                  input.parentNode.classList.add('has-floating-label')
                } else {
                  input.parentNode.classList.remove('has-floating-label')
                }
              })

              input.addEventListener('focus', () => {
                input.parentNode.classList.add('has-floating-label')
              })
            })
            
            formSelector.querySelector('[fs-field-validation-name="Sujet de votre demande"] select').addEventListener('change', (e) => {
              localStorage.setItem('contactSubject', e.target.value)
            })
          }
        }})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.current])

  return (
    <div className={inView ? 'has-anim' : 'no-anim'} ref={ref}>
      <h2 className="title title-slice title--white mb-6 scroll-anim-el" dangerouslySetInnerHTML={{__html: formTitle.replace(/\n/g, '<br />')}}></h2>

      <p className="paragraph-big paragraph-big--white scroll-anim-el scroll-anim-el--2" dangerouslySetInnerHTML={{__html: formChapo.replace(/\n/g, '<br />')}}></p>

      <div className="relative mt-10 scroll-anim-el scroll-anim-el--3">
        <div ref={form}></div>
        <p className="contact__mandatory text-14">{trads[lang].contact.mandatory}</p>
      </div>
    </div>
  )
}

export default Form